module.exports = "<div ng-form=\"telInputForm\">\n  <div class=\"input-field\"\n    ng-class=\"{\n      error: telInputForm.$invalid,\n      success: telInputForm.$valid && model\n    }\">\n    <input type=\"tel\"\n      id=\"{{id}}\"\n      name=\"{{id}}\"\n      ng-model=\"model\"\n      ng-intl-tel-input>\n    <div ng-hide=\"telInputForm.$pristine\"\n      class=\"center red-text\">\n      <span ng-show=\"telInputForm.$invalid\"\n        ng-bind-html=\"$root.logs.phone.invalid\">\n      </span>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/owners/phone/directives/inputs/myTelInput.html
// module id = 883
// module chunks = 0